module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_9016.b409ebf3.png";